import React, {useState, useEffect} from "react";

import {Select, SelectBaseOption, SelectProps} from "@britishcouncil/react-extro-ui";

export const AutoSelect = <TOption extends SelectBaseOption>({options, autoSelectEnabled, ...selectProps}: SelectProps<TOption> & {autoSelectEnabled: boolean}) => {
  const [initialized, setInitialized] = useState(false);
  useEffect(() => {
    if (!initialized && options.length === 1 && autoSelectEnabled) {
      // @ts-ignore
      selectProps.onChange(options[0], 'select-option');
    }
    setInitialized(true);
  }, [autoSelectEnabled, initialized, options, selectProps]);

  return <Select {...selectProps} options={options} />;
}
